// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2f11r","cell":"ColumnAccessor_cell__3Fa4c","firstCellAccent":"ColumnAccessor_firstCellAccent__3zTtC"};